module.exports = __webpack_public_path__ + "media/2.6a06b50b.mp3";